import script from "./ActionSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionSelector.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"ActionSelector.vue"]])

export default __exports__